<template>
    <div id="product-page" :style="{minHeight: bodyHeight}">
        <div class="product-banner">
            <img :src="img | urlProtocol" alt="">
        </div>
        <div class="activity-detail">
            <h2>{{activeStatus}}<span>{{day}}</span>天<span>{{hour}}</span>时<span>{{minutes}}</span>分</h2>
        </div>
        <div class="product-detail">
            <h2>{{commonName}}</h2>
            <div class="product-price">￥{{salePrice}} <span>￥{{price}}</span></div>
            <div class="book-tip">{{commonDesc}}</div>
        </div>
        <div class="activity-rules">
            <h2>活动规则</h2>
            <div>
                <img :src="ruleImg | urlProtocol" alt="">
            </div>
        </div>


    </div>
</template>
<script>
    import {Util} from '../commons/util'
    import Product from '@/components/commons/Product'
    import Server from '../services/Entrance';

    export default {
        name: 'Order',
        data () {
            return {
                bodyHeight: '',
                img: '',
                salePrice: '',
                price: '',
                ruleImg: '',
                startTime: '',
                endTime: '',
                commonName: '',
                commonDesc: '',
                day: '0',
                hour: '0',
                activeStatus: '距离活动结束还剩',
                minutes: '0'
            }
        },
        // 生命周期钩子
        mounted () {

            this.bodyHeight = window.screen.height + 'px';

            document.title = '商品详情';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '商品详情'
                        });
                    }
                })
            }
        },
        components: {
            Product
        },
        beforeRouteEnter(to, from, next) {

            let urlParams = to.params;

                Server.order.productRule(urlParams.goodsCode).then(data => {
                    next(vm => {

                        var endD = new Date(data.endTime.replace(/-/g, '/').replace(/\.\d*/g, ''));
                        var startD = new Date(data.startTime.replace(/-/g, '/').replace(/\.\d*/g, ''));
                        //var startD = new Date('2017-12-31 23:59:59.0'.replace(/-/g, '/').replace(/\.\d*/g, ''));

                        function setTime() {

                            var nowTime = new Date();

                            if (startD.getTime() <= nowTime.getTime()) {
                                var resTime = new Date(endD).getTime() - nowTime.getTime();
                                var leave1 = resTime % (24 * 3600 * 1000);
                                var leave2 = leave1 % (3600 * 1000);
                                vm.day = Math.floor(resTime/(24*3600*1000));
                                vm.hour = Math.floor(leave1 /(3600*1000));
                                vm.minutes = Math.floor(leave2 / (60 * 1000));
                            } else {
                                var resTime = new Date(startD).getTime() - nowTime.getTime();
                                var leave1 = resTime % (24 * 3600 * 1000);
                                var leave2 = leave1 % (3600 * 1000);
                                vm.day = Math.floor(resTime/(24*3600*1000));
                                vm.hour = Math.floor(leave1 /(3600*1000));
                                vm.minutes = Math.floor(leave2 / (60 * 1000));
                                vm.activeStatus = '距离活动开始还剩';
                            }
                        }
                        setTime();

                        setInterval(() => {
                            setTime();
                        }, 1000 * 60);

                        vm.img = data.goodsPic;
                        vm.salePrice = data.goodsDiscount;
                        vm.price = data.goodsPrice;
                        vm.commonName = data.goodsName;
                        vm.commonDesc = data.goodsDesc;
                        vm.ruleImg = data.goodsDetail;
                    });
                });
        },
        methods: {
        }
    }
</script>
<style scoped>
    #product-page {
        width: 100%;
        background: #f2f2f2;
    }

    .product-banner {
        background: #fff;
        width: 750px;
        height: 450px;

        img {
            display: block;
            overflow: hidden;
            width: 100%;
            height: 100%;
        }
    }
    .activity-detail {
        height: 80px;
        box-sizing: border-box;
        background: #f2f2f2;
        padding: 13px 19px;

        h2 {

            font-family: "PingFangSC-Medium";
            font-weight: bold;
            font-size:30px;
            color:#333333;

            span {
                margin: 0 5px;
                background:#ffaa00;
                border-radius:6px;
                width:42px;
                height:42px;
                line-height:42px;
                text-align: center;
                display: inline-block;
                color: #ffffff;
                font-weight: normal;
            }
        }

        .progress-bar {
            margin-top: 13px;
            width: 456px;
            height: 56px;
            line-height: 56px;
            background:#d8d8d8;
            border-radius: 200px;
            font-family:"PingFangSC-Medium";
            font-size:40px;
            color:#ffffff;
            transform: scale(0.5);
            padding: 0 20px;
            position: relative;
            transform-origin: left top;

            span {
                float: right;
            }

            b {
                 content: '';
                 display: block;
                 position: absolute;
                 top: 0;
                 left: 0;
                 height: 56px;
                 width: 100%;
                 border-radius: 200px;
                 z-index: -1;
                 background: #ffaa00;
             }
        }
    }
    .product-detail {
        margin-bottom: 10px;
        background: #fff;
        padding: 20px 19px;

        > h2 {
              font-weight: bold;
              font-family: "PingFangSC-Medium";
              font-size: 32px;
              color: #222222;
          }

          .product-price {
              margin-top: 10px;
              font-family:"PingFangSC-Regular";
              font-size:30px;
              color:#ff6600;

              span {
                  font-size:22px;
                  color:#b4b4b4;
                  margin-left: 12px;
                  text-decoration: line-through;
              }
          }
        .book-tip {
            margin-top: 23px;
            font-size:26px;
            color:#666666;
            line-height:40px;
        }
    }
    .activity-rules {
        display: block;
        padding: 20px 19px;
        background: #fff;
        font-size:26px;
        line-height: 40px;
        color:#666666;

        img {
            display: block;
            overflow: hidden;
            width: 100%;
        }

        > h2 {
              font-weight: bold;
              font-family: "PingFangSC-Medium";
              font-size: 32px;
              margin-bottom: 15px;
              color: #222222;
          }
    }
</style>



// WEBPACK FOOTER //
// src/components/ProductRule.vue